import styles from './index.module.less'
import Title from '@/components/BlockTitleTwo'
import icon from '@/assets/image/gea/blockchain.svg'
import SearchInput from '@/components/SearchInputTwo'
import BlockTitle from '@/components/BockTitle'
import CardInfo from './components/listCard/index'
import { useTranslation } from 'react-i18next'
import MePagination from '@/components/MePagination'
import { getRestBlockList } from '@/api/blocks'
import { I_Block, type I_BlockData } from '@/api/blocks/interface'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useRequest } from 'ahooks'
import LoadingCom from '@/components/LoadingCom'
import MePaginationNew from '@/components/MePaginationNew'
import MeEmpty from '@/components/MeEmpty'

const BlockChain = () => {
  const [pageParams, setPageParams] = useState<{
    offset: number
    limit: number
    page: number
  }>({
    offset: 0,
    limit: 10,
    page: 1,
  })
  const { t } = useTranslation()
  const [blockList, setBlockList] = useState<I_Block[]>([])
  const [total, setTotal] = useState<number>(0)
  const [allTotal, setAllTotal] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const blockKeyArray = useRef<{ [key: number]: string }>({
    0: '',
  })
  const blockGroupSize = useRef(0)
  const blockNextKey = useRef('')
  const [blockNextKeyData, setBlockNextKeyData] = useState<string>('')
  const blockCurrentGroupIndex = useRef(0)

  const blockPaginationPreAndNext = useMemo(() => {
    return {
      canNext: !!blockNextKeyData,
      canPrev: blockCurrentGroupIndex.current > 0,
    }
  }, [blockNextKeyData, blockCurrentGroupIndex.current])

  /** 参数组装 */
  const getPageParams = () => {
    const params: any = {
      offset: pageParams.offset,
      limit: pageParams.limit,
    }
    if (blockKeyArray.current[blockCurrentGroupIndex.current]) {
      params.key = blockKeyArray.current[blockCurrentGroupIndex.current]
    }

    return params
  }

  const { loading } = useRequest(() => getRestBlockList(getPageParams()), {
    refreshDeps: [pageParams, blockCurrentGroupIndex.current],
    onSuccess: (res: I_BlockData) => {
      if (res.blocks.length > 0) {
        setBlockList(res.blocks)
      }
      setTotal(Number(res.group_count || 0))
      setAllTotal(Number(res.total_count || 0))
      blockNextKey.current = res.next_key || ''
      setBlockNextKeyData(res.next_key || '')
      if (blockCurrentGroupIndex.current === 0 && res.next_key) {
        blockGroupSize.current = Number(res.group_count)
      }

      if (!isLoading) {
        setIsLoading(true)
      }
    },
  })

  return (
    <div className={styles.wrap}>
      <div className={styles.titleWrap}>
        {/* 区块 */}
        <Title title={t('explorer_3')} icon={icon} />
        <div className="search_input">
          <SearchInput placeholder={t('explorer_8')} />
        </div>
      </div>
      <div className={styles.paginationWrap}>
        {/* 区块列表 */}
        <div className={styles.title_wrap}>
          <BlockTitle title={t('explorer_147')}></BlockTitle>
          {isLoading ? (
            <>
              <div className={styles.total_num}>
                {t('explorer_93').replace('$txTotal', allTotal.toString())}
              </div>
            </>
          ) : null}
        </div>

        <div className="gea_pagination_box  gea_pagination_wrap">
          <MePaginationNew
            loading={loading}
            currentPage={pageParams.page}
            pageSize={pageParams.limit}
            setPageParams={setPageParams}
            total={total}
            paginationPreAndNext={blockPaginationPreAndNext}
            groupSize={blockGroupSize.current}
            groupIndex={blockCurrentGroupIndex.current}
            prevKeyFn={() => {
              if (loading) return
              if (blockCurrentGroupIndex.current === 0) return
              if (blockCurrentGroupIndex.current > 0) {
                blockCurrentGroupIndex.current--
              }
              setPageParams({
                offset: 0,
                limit: pageParams.limit,
                page: 1,
              })
            }}
            nextKeyFn={() => {
              if (loading) return
              if (!blockNextKey.current) return
              blockCurrentGroupIndex.current++
              blockKeyArray.current[blockCurrentGroupIndex.current] = blockNextKey.current
              setPageParams({
                offset: 0,
                limit: pageParams.limit,
                page: 1,
              })
            }}
          />
        </div>
      </div>
      <div className={styles.cardWrap}>
        {loading && <LoadingCom />}
        {!loading && !blockList.length ? <MeEmpty></MeEmpty> : null}
        {blockList.map((item) => (
          <CardInfo key={item.height} cardData={item} />
        ))}
      </div>
      <div className={styles.footerPage}>
        <div className="gea_pagination_wrap">
          <MePaginationNew
            loading={loading}
            currentPage={pageParams.page}
            pageSize={pageParams.limit}
            setPageParams={setPageParams}
            total={total}
            paginationPreAndNext={blockPaginationPreAndNext}
            groupSize={blockGroupSize.current}
            groupIndex={blockCurrentGroupIndex.current}
            prevKeyFn={() => {
              if (loading) return
              if (blockCurrentGroupIndex.current === 0) return
              if (blockCurrentGroupIndex.current > 0) {
                blockCurrentGroupIndex.current--
              }
              setPageParams({
                offset: 0,
                limit: pageParams.limit,
                page: 1,
              })
            }}
            nextKeyFn={() => {
              if (loading) return
              if (!blockNextKey.current) return
              blockCurrentGroupIndex.current++
              blockKeyArray.current[blockCurrentGroupIndex.current] = blockNextKey.current
              setPageParams({
                offset: 0,
                limit: pageParams.limit,
                page: 1,
              })
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default BlockChain
